import { render, staticRenderFns } from "./Register.form.vue?vue&type=template&id=d03c2918&scoped=true&lang=pug&"
import script from "./Register.form.vue?vue&type=script&lang=ts&"
export * from "./Register.form.vue?vue&type=script&lang=ts&"
import style0 from "./Register.form.vue?vue&type=style&index=0&id=d03c2918&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d03c2918",
  null
  
)

export default component.exports